export default {"src":"/_next/static/media/dealerIcon.5601327c.svg","height":24,"width":24};